export default "__VITE_ASSET__DyAMlGHG__"